import { toIso3166Alpha2 } from "src/utils/countryCodes";

// Address countries are stored inconsistently ("AU", "AUS", "Australia"), so
// resolve to the ISO code rather than comparing the raw string.
export function isAuCountry(country?: string | null): boolean {
  return toIso3166Alpha2(country) === "AU";
}
